import { createCn } from 'shared-utils'

export const bubbleLinkCn = createCn('bubble-link')
